import { formatDayMonth, toLocalIsoDate } from "@acto/taskpane/field-sales-2/utils/format";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export function startOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Whole days between [dueDate] (local midnight) and [today]; positive when overdue. */
export function daysOverdue(dueDate: Date, today: Date = startOfToday()): number {
  // UTC anchors per calendar day: local midnights sit 23/25h apart across a DST switch.
  return Math.floor(
    (Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) -
      Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate())) /
      MS_PER_DAY,
  );
}

/** "12. Apr." / "Apr 12" style label, or undefined when the todo has no due date. */
export function todoDueDateLabel(dueDate: Date | undefined, locale: string): string | undefined {
  return dueDate ? formatDayMonth(toLocalIsoDate(dueDate), locale) : undefined;
}
